import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {DomSanitizer} from '@angular/platform-browser';
import {DocumentTypeModel} from '../../../../shared/dto/document-type.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApplicantRequestService} from '../../../../service/applicant-request.service';
import {BlacklistDocsViewerComponent} from '../../../../reversed-blacklist-process/blacklist-docs-viewer/blacklist-docs-viewer.component';
import {DocumentDetailsService} from '../../../../service/document-details.service';

@Component({
  selector: 'app-reversed-suspend-blacklist-verify-document',
  templateUrl: './reversed-suspend-blacklist-verify-document.component.html',
  styleUrls: ['./reversed-suspend-blacklist-verify-document.component.scss']
})
export class ReversedSuspendBlacklistVerifyDocumentComponent implements OnInit {
  @Input() applicationId: number;
  @Input() types: string;
  public documentTypeModel: DocumentTypeModel[];
  displayedColumns: string[] = ['description','action'];
  dataSource: MatTableDataSource<any>;
  public pages: any = [];
  public loader: boolean = false;
  docType: DocumentTypeModel = new DocumentTypeModel();

  constructor(private applicantRequestService: ApplicantRequestService, private documentDetailsService: DocumentDetailsService,
              private sanitizer: DomSanitizer, private modalService: NgbModal,) { }

  ngOnInit() {
    this.getDocumentType();
  }

  getDocumentType() {
    this.applicantRequestService.getDocumentType(this.applicationId).subscribe(
      (result: any ) => {
        this.documentTypeModel = result;
        this.dataSource = new MatTableDataSource(this.documentTypeModel);
      }
    );
  }

  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  viewDoc(documentTypeCode:string) {
    this.docType.appRefID = this.applicationId;
    this.docType.documentTypeCode = documentTypeCode;

    const modalRef = this.modalService.open(BlacklistDocsViewerComponent,{size: 'lg'});
    let data = {
      doc: this.docType,
    }

    modalRef.componentInstance.fromParent = data;
  }


}
